// src/pages/support/WorkplaceGiving.js
import React from "react";
import { Helmet } from "react-helmet";
import SupportOpportunity from "../../components/SupportOpportunity";
import dummyImage from "../../assets/images/support/matching.webp"; // Path to your dummy image
import CTASection from "../../components/CTASection"; // Import the CTASection component
import styled from "styled-components"; // Import styled-components for custom styling

const WorkplaceGiving = () => {
  const description = `
    Support Habitat for Humanity Buffalo through workplace giving and matching gifts. Many employers offer matching gift programs that can double or even triple your contribution. Check with your employer to see if they participate in a matching gift program.
  `;

  const waysToSupport = [
    "Payroll deductions",
    "Employer matching gift programs",
    "Corporate grants",
  ];

  return (
    <>
      <Helmet>
        <title>
          Workplace Giving and Matching Gifts - Habitat for Humanity Buffalo
        </title>
        <meta
          name="description"
          content="Support Habitat Buffalo through workplace giving and matching gifts. Double or triple your contribution with employer matching gift programs."
        />
      </Helmet>
      <SupportOpportunity
        title="Workplace Giving and Matching Gifts"
        image={dummyImage}
        description={description}
        waysToSupport={waysToSupport}
      />

      <CTAContainer>
        <CTASection
          title="Get Started with Workplace Giving"
          description="Please fill out the form below to get started with workplace giving. Our team will get in touch with you shortly."
          buttonText="Start Workplace Giving"
          buttonLink="/form/workplaceGiving"
        />
      </CTAContainer>
    </>
  );
};

// Wrap CTASection in a styled container
const CTAContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

export default WorkplaceGiving;
